export function searchForFormById(forms, id) {
  const form =
    forms.filter(form => form.formId == id);
  if (form){
    return form[0];
  }
  return null;
}

export function searchForInjurySummary(summaries, id) {
  const injurySummary =
    summaries.filter(injurySummary => {
      if(injurySummary){
        return injurySummary.id == id;
      }
    });
  if (injurySummary) {
    return injurySummary[0];
  }
  return null;
}

export function searchForInjurySummaryByFilingYear(summaries, filingYear) {
  const injurySummary =
    summaries.filter(injurySummary => {
      if(injurySummary){
        return injurySummary.filingYear == filingYear;
      }
    });
  if (injurySummary) {
    return injurySummary[0];
  }
  return null;
}

export function searchForCaseData(casedatas, id) {
  const caseData =
  casedatas.filter(caseData => {
      if(caseData){
        return caseData.id == id;
      }
    });
  if (caseData) {
    return caseData[0];
  }
  return null;
}


/** WEBPACK FOOTER **
 ** ./src/selectors/searchForForm.js
 **/